import settings from "../../../../constants/settings";
import useFetchAndTrace from "../../fetchWithTrace";
import { useCallback } from "react";
import { Response } from "next/dist/compiled/@edge-runtime/primitives";

export default function useNotifyInstantQuoted(
  onError: () => void,
  onSuccess: () => void,
) {
  const fetchAndTrace = useFetchAndTrace();

  const notifyCustomerHandler = useCallback(
    (response: Response) => {
      if (response.ok) {
        onSuccess?.();
      } else {
        throw Error("Failed to email customer about instant quote.");
      }
    },
    [onSuccess],
  );

  const notifyBoardIsPurchasable = useCallback(
    (boardId: string) => {
      void fetchAndTrace(
        `${settings.api_url}/boards/${boardId}/board-is-purchasable`,
        notifyCustomerHandler,
        onError,
      );
    },
    [notifyCustomerHandler, fetchAndTrace, onError],
  );

  return { notifyBoardIsPurchasable };
}
